/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/no-observers */
import DynamicField from '@linc-technologies/linced-common/components/dynamic-field';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { observes } from '@ember-decorators/object';
import { tracked } from '@glimmer/tracking';

export default class DynamicFieldDefault extends DynamicField {
  layoutName = 'components/dynamic-field';

  @service
  store;
  @tracked isInitialised;

  // Override the field's `isRequired` property so that the default is never required.
  //
  // NOTE: must stay a getter. The DynamicField we extend defines `isRequired`
  // as an `@or(...)` computed macro, so a class field would assign over it at
  // construction time and trigger the `computed-property.override` deprecation.
  get isRequired() {
    return false;
  }

  // There's no entity, so a basic dirtiness check is all we can do.
  @computed('entityField.hasDirtyAttributes', 'isReadOnly')
  get isDirty() {
    if (this.isReadOnly) {
      // Don't render the field as "dirty" if it's read-only.
      return false;
    }
    return this.get('entityField.hasDirtyAttributes');
  }

  @observes('field.dataType')
  dataTypeChanged() {
    this.isInitialised = false;
    this.getEntityField();
    this.hasFieldMeta();
  }

  // Overrides the dynamic-field `entityField` computed property
  // to ensure that the field value updates when the field's datatype is changed.
  @computed('fieldKey', 'entity.id', 'field.{dataType,default}')
  get entityField() {
    return this.getEntityField();
  }

  getEntityField() {
    let field = this.get('field.default');
    let dataType = this.get('field.dataType');
    if (isEmpty(field)) {
      // Create a new fieldValue if we don't have one yet.
      field = this.createEntityField();
    } else if (field.datatype !== dataType) {
      // If the datatype has changed, update the existing default value's datatype.
      this.get('field.default').set('datatype', dataType);
    }
    return field;
  }

  createEntityField() {
    let field = {
      datatype: this.get('field.dataType'),
    };
    this.field.set(
      'default',
      this.store.createFragment('dynamic-field/value', field),
    );
    return this.get('field.default');
  }

  hasFieldMeta() {
    this.initValue();
  }
}
